// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesEdu = {
  eduCourse: "コース",
  eduLearningRecord: "学習記録",
  eduMember: "EDU メンバー",
  eduOrg: "EDU 組織",
  eduOverviewLearnerMessage: "学習者メッセージ",
  eduProject: "プロジェクト演習",
  eduPublicCourse: "公開コース",
  eduTeachingPlan: "授業計画",
  eduAuth: "EDU 認証",
  eduOverview: "EDU 概要",
} as const;
